import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { GenericLayer } from '../../../../../shared/model/layers/generic-layer'
import { SelectionLayer } from 'src/app/shared/model/layers/selection-layer'
import { LayerReference } from '../layer-groups.model'
import { viewerActions } from 'src/app/state/viewer/viewer.actions'
import { Store } from '@ngrx/store'
import { ViewerLayersService } from 'src/app/case-viewer/neuroglancer-frame/viewer-layers.service'
import { take } from 'rxjs'
import { ViewerLayersComponent } from '../../viewer-layers.component'

@Component({
    selector: 'app-layer-group-item',
    templateUrl: './layer-group-item.component.html',
    styleUrls: ['./layer-group-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayerGroupItemComponent {
    @Input() layer: GenericLayer | SelectionLayer

    @Output() selectLayer = new EventEmitter<LayerReference>()
    constructor(
        private readonly store: Store,
        private readonly viewerLayers: ViewerLayersService,
        private viewerLayersComponent: ViewerLayersComponent
    ) {}

    selectLayerClicked(layer: any, elementId: string): void {
        this.viewerLayersComponent.isLoading = true
        if (!layer.nameOrDefault) {
            this.store.dispatch(
                viewerActions.setLocalLayerVisibility({
                    id: layer.id,
                    visible: false,
                })
            )
            this.viewerLayers.layers$.pipe(take(1)).subscribe((layers: GenericLayer[]) => {
                const selectedLayer = layers.find(l => l.name === layer.name)
                if (selectedLayer) {
                    this.viewerLayersComponent.toggleLayerDetailOverlay({
                        layer: selectedLayer,
                        elementId,
                    })
                }
                this.viewerLayersComponent.isLoading = false
            })
        } else {
            this.viewerLayersComponent.toggleLayerDetailOverlay({
                layer,
                elementId,
            })
            this.viewerLayersComponent.isLoading = false
        }
    }

    toggleLayerVisibility(event: MouseEvent, layer: any): void {
        if (layer.id) {
            this.store.dispatch(
                viewerActions.setLocalLayerVisibility({
                    id: layer.id,
                    visible: true,
                })
            )
        } else {
            layer.toggleVisible()
        }
        event.stopPropagation()
    }

    isSelectionLayer(layer: GenericLayer | SelectionLayer): layer is SelectionLayer {
        return (layer as SelectionLayer).level !== undefined
    }
}
